import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;

let cancelRead;
class AddressApi extends Api {
  constructor() {
    super('addresses', 'addresses');
  }

  async readData(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }
}
const addressApi = new AddressApi();

export default addressApi;
